module.exports = __webpack_public_path__ + "static/img/inz_ico_1.ee434a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inz_ico_1.png
// module id = srja
// module chunks = 1